<template>
  <div>
    <!-- Alerta de checkout (single) -->
    <b-alert
      v-if="shouldShowCheckoutAlert(singleStoreId)"
      show
      variant="warning"
      class="text-center mb-3"
    >
      <p>
        <span class="fas fa-exclamation-triangle mr-1" />
        {{ getCheckoutAlertMessage(singleStoreId) }}
      </p>
      <b-button
        v-if="isAdmin"
        size="sm"
        variant="warning"
        :to="{ name: 'CheckoutsIndex' }"
      >
        Abrir Caixa
      </b-button>
    </b-alert>

    <template v-else>
      <div v-if="canShowStoreItems(singleStoreId)">
        <!-- Brinquedos -->
        <div
          v-if="toysByStore[singleStoreId] && toysByStore[singleStoreId].length"
          class="toys-grid mb-3"
        >
          <ToyRentListItem
            v-for="toy in toysByStore[singleStoreId]"
            :key="'toy__' + toy.id"
            :toy="toy"
            :disabled="!hasOpenCheckout(singleStoreId)"
            :selection-mode-active="selectionModeActive"
            :checkouts-by-store="checkoutsByStore"
            @update-store-id="$emit('update-store-id', singleStoreId)"
            @trigger-action="$emit('trigger-action', $event)"
            @activate-selection-mode="$emit('activate-selection-mode', $event)"
            @new-rental="$emit('new-rental', $event)"
            @reload="$emit('reload')"
            @emitPaymentAmountsForMultiFormatPayments="
              $emit('emitPaymentAmountsForMultiFormatPayments', $event)
            "
          />
        </div>

        <!-- Produtos -->
        <div
          v-if="
            productsByStore[singleStoreId] &&
            productsByStore[singleStoreId].length
          "
          class="toys-grid"
        >
          <ProductListItem
            v-for="product in productsByStore[singleStoreId]"
            :key="'product__' + product.id"
            :product="product"
            :disabled="!hasOpenCheckout(singleStoreId)"
            @trigger-action="$emit('trigger-action', $event)"
          />
        </div>

        <!-- Vazio -->
        <b-alert
          v-if="
            (!toysByStore[singleStoreId] ||
              !toysByStore[singleStoreId].length) &&
            (!productsByStore[singleStoreId] ||
              !productsByStore[singleStoreId].length)
          "
          show
          variant="secondary"
          class="text-center"
        >
          Nenhum item disponível nesta loja com os filtros aplicados.
        </b-alert>
      </div>

      <!-- Caixa fechado/indisponível -->
      <b-alert v-else show variant="info" class="text-center">
        Não é possível exibir os itens pois o estado do caixa desta loja não
        pôde ser determinado ou o caixa não está aberto para hoje.
        <b-button
          v-if="isAdmin"
          size="sm"
          variant="info"
          :to="{ name: 'CheckoutsIndex' }"
        >
          Verificar Caixas
        </b-button>
      </b-alert>
    </template>
  </div>
</template>

<script>
import ToyRentListItem from '../../ToyRentListItem.vue'
import ProductListItem from '../../ProductListItem.vue'

export default {
  name: 'SingleStoreBoard',
  components: { ToyRentListItem, ProductListItem },
  props: {
    singleStoreId: { type: [String, Number], required: true },

    toysByStore: { type: Object, required: true },
    productsByStore: { type: Object, required: true },

    selectionModeActive: { type: Boolean, default: false },
    checkoutsByStore: { type: Object, required: true },

    // Funções vindas do pai
    hasOpenCheckout: { type: Function, required: true },
    canShowStoreItems: { type: Function, required: true },
    shouldShowCheckoutAlert: { type: Function, required: true },
    getCheckoutAlertMessage: { type: Function, required: true },
    getStoreName: { type: Function, required: false }, // opcional

    isAdmin: { type: Boolean, default: false }
  },
  emits: [
    'update-store-id',
    'trigger-action',
    'activate-selection-mode',
    'new-rental',
    'reload',
    'emitPaymentAmountsForMultiFormatPayments'
  ]
}
</script>

<style scoped>
/* usa o mesmo grid do pai (ou copie para cá) */
.toys-grid {
  display: grid;
  gap: 0.5rem;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
}
@media (min-width: 350px) {
  .toys-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media (min-width: 580px) {
  .toys-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}
@media (min-width: 992px) {
  .toys-grid {
    grid-template-columns: repeat(4, 1fr);
  }
}
@media (min-width: 1200px) {
  .toys-grid {
    grid-template-columns: repeat(5, 1fr);
  }
}
</style>
